// Needed to detect if any non-jQuery AJAX requests are still pending (like SignalR).
(function () {
    var origOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function () {
        if (!window._ajaxRequests) {
            window._ajaxRequests = 0;
        }

        this.addEventListener('loadstart', function () {
            window._ajaxRequests++;
        });

        this.addEventListener('loadend', function () {
            window._ajaxRequests--;
        });

        origOpen.apply(this, arguments);
    };
})();